import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import PublishCouponForm from "@/Pages/Coupons/Assets/PublishCouponForm";

const PublishingCoupons = () => {
  const {coupon, discount_type} = usePage().props
  const {data, setData, errors, post, processing} = useForm({
    discount_type: 1,
    value: 0.00,
    max_value: 0.00,
    min_amount: 0.00,
    free_ship: false,
    comments: '',
    keywords: '',
    link_name: '',
    showonline: false,
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('added.coupons.publish', coupon.id).url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('added.coupons')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Added Coupons
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Coupon Publication
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <PublishCouponForm data={data} discount_type={discount_type} setData={setData} errors={errors}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Publish a coupon
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

PublishingCoupons.layout = page => <Layout title="Coupon Publication" children={page}/>;

export default PublishingCoupons;
